<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
          <div class="row">
            <div :class="parseInt(status.status) === 2 ? 'col-sm-3' : 'col-sm-6'">
              <div class="form-group">
                <label for="status">Status</label>
                <select
                  class="custom-select"
                  name="status"
                  v-model="status.status"
                  :class="{
                    'is-invalid': submitted && $v.status.status.$error
                  }"
                >
                <option v-for="(p, i) in statusSelect" :key=i :value="p.id">{{ p.name }}</option>
                </select>
                <div
                  v-if="submitted && !$v.status.status.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-3" v-if="parseInt(status.status) === 2">
              <div class="form-group">
                <label for="refStatus">Tipo Pendência</label>
                <select
                  class="custom-select"
                  name="refStatus"
                  v-model="status.refStatus"
                  :class="{
                    'is-invalid': submitted && $v.status.refStatus.$error
                  }"
                >
                <option v-for="(p, i) in refstatusList" :key=i :value="i">{{ p }}</option>
                </select>
                <div
                  v-if="submitted && !$v.status.refStatus.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="name">Template</label>
                <select
                  class="custom-select"
                  name="template_name"
                  v-model="status.template_id"
                  @change="setTemplate(status.template_id)"
                  :class="{
                    'is-invalid': submitted && $v.status.template_id.$error
                  }"
                >
                  <option value=""></option>
                  <option v-for="(t,i) in templates" :key=i :value="t.id">{{ t.namespace }}</option>
                </select>
                <div
                  v-if="submitted && !$v.status.template_id.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <!-- Aviso quando o template usa QRCode dinâmico do participante.
               Nesse caso o operador não precisa subir imagem — o sistema
               injeta o QR único de cada participante no envio. -->
          <div class="row" v-if="showHeader && isDynamicQrTemplate">
            <div class="col-sm-12">
              <div class="sw-qr-info">
                <div class="sw-qr-info-icon">
                  <i class="bx bx-qr-scan"></i>
                </div>
                <div>
                  <div class="sw-qr-info-title">Header dinâmico ativado</div>
                  <div class="sw-qr-info-desc">
                    Este template usa <strong>QR Code do participante</strong> no header.
                    Cada destinatário receberá automaticamente o próprio QR único —
                    você não precisa anexar nenhuma imagem aqui.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="showHeader && !isDynamicQrTemplate">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="header_banner">Header Imagem</label>
                <input
                  class="form-control"
                  ref="header_banner"
                  name="header_banner"
                  type="file"
                >
                <div
                  v-if="showHeader"
                  class="invalid-feedback"
                >
                  Template escolhido exige uma imagem no HEADER.
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveStatus()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Swal from 'sweetalert2'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    idTemplate: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Novo',
      loading: true,
      fullPage: true,
      submitted: false,
      template: {},
      status: {},
      modal: false,
      showHeader: false,
      isDynamicQrTemplate: false
    }
  },
  validations () {
    let valid = {
      status: { required },
      template_id: { required }
    }
    if (this.status.status === 2) {
      valid = {
        ...valid,
        refStatus: { required }
      }
    }
    return { status: valid }
  },
  mounted () {
  },
  methods: {
    ...mapActions('template', {
      getTemplatesAll: 'getAll'
    }),
    ...mapActions('settings', { GetStatus: 'GetStatusSelect', GetRefStatus: 'GetRefStatusList' }),
    ...mapActions('statusTemplate', {
      getStatusTemplate: 'show',
      postData: 'save'
    }),
    setTemplate (templateId) {
      if (templateId) {
        const template = this.templates.filter((t) => t.id === this.status.template_id)[0]
        if (template) {
          this.showHeader = template.components[0].format === 'IMAGE'
          // Template marcado como QR dinâmico → não pede upload de banner
          this.isDynamicQrTemplate = template.dynamic_header_type === 'participant_qrcode'
        } else {
          this.showHeader = false
          this.isDynamicQrTemplate = false
        }
      } else {
        this.showHeader = false
        this.isDynamicQrTemplate = false
      }
    },
    deleteTemplate (template) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido o template: <b>${template.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.delete(template.id)
            successMessage('Sucesso: Template excluído com sucesso.', 2500)
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    },
    // setTemplate (template) {
    //   if (template) {
    //     this.template.name = template.name
    //     this.template.namespace = template.name
    //     this.template.language_code = template.language.code
    //     this.template.components = template.components
    //     return
    //   }
    //   this.template = {}
    // },
    loadItem (id) {
      if (id) {
        this.title = 'Editar Status'
        this.getStatusTemplate(id).then((data) => {
          this.status = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      this.getTemplatesAll()
      this.GetStatus()
      this.GetRefStatus()
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveStatus () {
      this.submitted = true
      this.$v.status.$touch()
      if (this.$v.status.$invalid) {
        window.scroll(0, 0)
        return
      }

      // if (!this.$refs.header_banner.files[0] && this.showHeader) {
      //   errorMessage('Alerta: Você precisa anexar uma imagem')
      //   return
      // }
      this.loading = true
      const formData = new FormData()
      formData.append('id', this.status.id || '')
      formData.append('status', this.status.status)
      formData.append('refStatus', this.status.refStatus)
      formData.append('template_id', this.status.template_id)
      // Pula upload de banner quando o template usa QR dinâmico — backend
      // injeta o QR do participante no envio, não precisa de imagem aqui.
      if (this.showHeader && !this.isDynamicQrTemplate) {
        formData.append('header_banner', this.$refs.header_banner.files[0] ? this.$refs.header_banner.files[0] : '')
      }

      await this.postData(formData).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.template = {}
        this.$v.$reset()
        this.loading = false
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.status = {}
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['statusSelect', 'refstatusList']),
    ...mapState('template', ['templates']),
    ...mapState('statusTemplate', { data: 'statusTemplate' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}

.sw-qr-info {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  background: rgba(85, 110, 230, 0.05);
  border: 1px solid rgba(85, 110, 230, 0.2);
  border-radius: 10px;
  margin-bottom: 16px;
}
.sw-qr-info-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: #fff;
  border-radius: 8px;
  color: #556ee6;
  font-size: 22px;
}
.sw-qr-info-title { font-size: 13px; font-weight: 600; color: #1a1d26; margin-bottom: 4px; }
.sw-qr-info-desc { font-size: 12px; color: #667085; line-height: 1.5; }
</style>
